// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"selectedTransaction_PageHeader__3FfiP"};